export default __webpack_public_path__ + "static/unleash-joy-f2c8053eedebaf6e678d2fcb1262c024.svg";